import { render } from "./MedicalCourse.vue?vue&type=template&id=11fbfe5c&scoped=true"
import script from "./MedicalCourse.vue?vue&type=script&lang=js"
export * from "./MedicalCourse.vue?vue&type=script&lang=js"

import "./MedicalCourse.vue?vue&type=style&index=0&id=11fbfe5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11fbfe5c"]])

export default __exports__